<template>
  <div class="online-course">
    <navbar />

    <div class="foundation">
      <b-container
        class="foundation-container"
        fluid
        style="padding: 0px !important;"
      >
        <b-row class="no-gutters">
          <b-col class="d-flex flex-column" sm="6">
            <!-- <div class="foundation-header d-flex p-2"></div> -->
            <div class="foundation-content">
              <h2>Introduction to Variables &amp; Operators</h2>
              <div class="videoWrapper m-4">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/zb-Y4vM2r0c"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <h2>Conditionals</h2>
              <div class="videoWrapper m-4">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/ag_yl2iovlg"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>

              <h2>Loops</h2>
              <div class="videoWrapper m-4">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/9-B4cTpjGIg"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>

              <h2>Functions</h2>
              <div class="videoWrapper m-4">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/s_prdhZGVwM"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>

              <h2>List</h2>
              <p>Coming soon...</p>
            </div>
          </b-col>
          <b-col>
            <div class="foundation-actionbar d-flex justify-content-end">
              <b-button class="my-auto mr-2" @click="viewCode">
                View Code
              </b-button>
              <b-button
                variant="danger"
                class="my-auto mr-2"
                @click="resetWorkspace"
              >
                Reset
              </b-button>
              <b-button variant="primary" class="my-auto mr-2" @click="runCode">
                <font-awesome-icon
                  class="mr-2"
                  :icon="['fas', 'play']"
                  style="color: white;"
                />Run
              </b-button>
            </div>
            <div id="blocklyDiv"></div>
          </b-col>
        </b-row>
      </b-container>

      <b-modal v-model="showCode" title="JavaScript Code">
        <p class="my-4" style="white-space:pre-wrap;">
          {{ code }}
        </p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Blockly from "blockly";
import Interpreter from "js-interpreter";
import toolbox from "@/toolbox/playground";

import Navbar from "@/components/Navbar.vue";

export default {
  name: "Foundation",

  components: {
    Navbar
  },

  data() {
    return {
      id: this.$route.params.id
    };
  },

  mounted() {
    this.injectBlockly();
  },

  computed: {},

  methods: {
    injectBlockly() {
      this.workspace = Blockly.inject(document.getElementById("blocklyDiv"), {
        trashcan: true,
        toolbox: toolbox,
        zoom: {
          controls: true,
          wheel: true
        }
      });
    },

    viewCode() {
      this.code = Blockly.JavaScript.workspaceToCode(this.workspace);
      this.showCode = true;
    },

    runCode() {
      let workspaceCode = Blockly.JavaScript.workspaceToCode(this.workspace);
      let code = this.appendCode(workspaceCode);
      let myInterpreter = new Interpreter(code, this.getInitApi());
      myInterpreter.run();
    },

    appendCode(code) {
      return code;
    },

    getInitApi() {
      return (interpreter, scope) => {
        let alertWrapper = function(text) {
          return alert(arguments.length ? text.data : "");
        };

        interpreter.setProperty(
          scope,
          "alert",
          interpreter.createNativeFunction(alertWrapper)
        );

        let promptWrapper = function(text) {
          return prompt(text);
        };
        interpreter.setProperty(
          scope,
          "prompt",
          interpreter.createNativeFunction(promptWrapper)
        );
      };
    },

    resetWorkspace() {
      if (confirm("Are you sure you want to reset playground?")) {
        this.result = {};
        document.getElementById("blocklyDiv").innerHTML = "";
        this.code = "";
        this.injectBlockly();
      }
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    next();
  }
};
</script>

<style lang="less" scoped>
.foundation {
  &-header {
    background-color: rgb(255, 223, 137);

    &-title {
      line-height: 1.25rem;
      font-size: 1.25rem;
    }
  }

  &-content {
    padding: 15px;
    overflow: auto;
    height: calc(100vh - 45px);
  }

  &-actionbar {
    height: 54px;
  }
}

#blocklyDiv {
  height: calc(100vh - 110px);
  width: 100%;
}

.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
